import React from "react";
import { Redirect } from "react-router-dom";

/** Legacy dashboard AI insights sub-page → My AI Insights. */
const TopProblemsRedirect = () => <Redirect to="/console/my-workspace" />;

export default TopProblemsRedirect;
